<template>
    <div class = "print" v-if="getPermission.stc.view || getPermission.stc.view">

        <md-tabs md-sync-route class="settlement-and-report-tabs">
          <md-tab id="tab-payroll_settlement" md-label="Settlement" to="/payroll/settlement"></md-tab>
          <md-tab id="tab-payroll_report" md-label="Report" to="/payroll/report"></md-tab>
        </md-tabs>
        <router-view/>

    </div>

</template>

<style lang="scss">

  .settlement-and-report-tabs {
    .md-tabs-navigation {
      .md-theme-default {
        height: 30px;
      }
    }
  }

  


</style>


<script>
  import { mapGetters } from 'vuex';

  export default {
    data: () => ({}),
    computed: {
      ...mapGetters([
        'getPermission',
        'getMasterDataName',
      ]),
    },
  };

</script>



